module.exports = __webpack_public_path__ + "img/banner-nosotros-desk-min.9b5582d7.jpg";